if(window.wp && window.wp.blocks) {

    window.wp.blocks.registerBlockStyle( 'core/heading', {
        name: 'h1',
        label: 'Imitate Heading 1'
    } );

    window.wp.blocks.registerBlockStyle( 'core/heading', {
        name: 'h2',
        label: 'Imitate Heading 2'
    } );

    window.wp.blocks.registerBlockStyle( 'core/heading', {
        name: 'h3',
        label: 'Imitate Heading 3'
    } );

    window.wp.blocks.registerBlockStyle( 'core/heading', {
        name: 'h4',
        label: 'Imitate Heading 4'
    } );

    window.wp.blocks.registerBlockStyle( 'core/heading', {
        name: 'h5',
        label: 'Imitate Heading 5'
    } );

    window.wp.blocks.registerBlockStyle( 'core/heading', {
        name: 'h6',
        label: 'Imitate Heading 6'
    } );

}
